export async function fetchData(body, options) {
  const token = options.token || localStorage.getItem('lltoken');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await fetch(`/api/graph`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      ...headers
    },
    body: JSON.stringify(body)
  });
  return await res.json();
}
